<template>
    <v-container fluid>
        <v-row v-if="isLoading">
            <v-col>
                <loading-spinner></loading-spinner>
            </v-col>
        </v-row>
        <v-row v-else>
            <v-col>
                <v-card>
                    <card-header 
                    :title="$t('title.paper_publish_management')" 
                    icon="toc" 
                    color="primary" 
                    variant="gradient"
                    ></card-header>
                    <v-card-text>
                        <v-data-table 
                        :headers="columns" 
                        :items="contents" 
                        disable-pagination 
                        hide-default-footer
                        >
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td>{{ item.title }}</td>
                                    <td>{{ item.title_eng }}</td>
                                    <td> 
                                        <custom-button icon="edit" color="primary" size="xs" gradient fab @click="toEditPublishedPaper(item)"></custom-button>
                                        <custom-button icon="check" color="green" size="xs" gradient fab @click="handlePublish(item)"></custom-button>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <confirm-dialog 
            :title="$t('label.publish_confirm')" 
            :description="$t('txt.publish_confirm_description')" 
            :confirm-button-text="$t('button.yes')"
            :cancel-button-text="$t('button.no')"
            :dialog="dialog"
            @update:dialog="dialog = $event"
            @confirm="confirmPublish"
            @cancel="cancelPublish"
        ></confirm-dialog>
    </v-container>
</template>
<script>
    import CardHeader from "@/components/cards/CardHeader.vue";
    import LoadingSpinner from '@/components/common/Spinners/LoadingSpinner.vue';
    import CustomButton from '@/components/common/buttons/CustomButton.vue';
    import ConfirmDialog from '@/components/common/Modal/ConfirmDialog.vue';

    import { paperPublishManagementColumns } from '@/fields/journal/columns';
    import { journalContentApi } from '@/api/api';


    export default {
        components: {
            LoadingSpinner,
            CardHeader,
            CustomButton,
            ConfirmDialog,
        },
        data() {
            return {
                isLoading: false,
                selectedPaper: null,
                dialog: false,
                contents: [],
                columns: paperPublishManagementColumns,
            }
        },
        methods: {
            /**
             * ****************************************************************************************
             * 페이지 이동
             * ****************************************************************************************/
            async toEditPublishedPaper(item) {
                this.$router.push({ path: `/journals/papers/edit/${item.idx}` });
            },
            /**
             * ****************************************************************************************
             * 버튼 액션
             * ****************************************************************************************/
            async handlePublish(paper) {
                this.dialog = true;
                this.selectedPaper = paper;
            },
            async confirmPublish() {
                try {
                    await this.updateAcceptedStatus(this.selectedPaper);
                    await this.fetchContents();
                } catch (error) {
                } finally {
                    this.dialog = false;
                    this.selectedPaper = null;
                }
            },
            async cancelPublish() {
                this.dialog = false;
                this.selectedPaper = null;
            },
            /**
             * ****************************************************************************************
             * api 호출
             * ****************************************************************************************/
            async fetchContents() {
                try {
                    this.isLoading = true;
                
                    const response = await journalContentApi.showAllByCategory({
                        category: "paper",
                        accepted: "N",
                    });
                    this.contents = response.data.response;
                } catch (error) {
                    this.notifyVue({
                        message: this.$t("alert.request_failed"),
                    });
                } finally {
                    this.isLoading = false;
                }
            },
            async updateAcceptedStatus(item) {
                try {
                    await journalContentApi.updateJournalContentAcceptedStatus({
                        idx: item.idx,
                    });
                    this.notifyVue({
                        message: this.$t("alert.success_request"),
                        style: "success",
                        icon: "check",
                    });
                } catch (error) {
                    this.notifyVue({
                        message: this.$t("alert.failed_request"),
                        style: "error",
                    });
                }
            },
            /* ****************************************************************************************
            * 알럿
            * ****************************************************************************************/
            notifyVue({
                vertical = "top",
                horizontal = "right",
                message = "",
                style = "primary",
                icon = "priority_high",
                } = {}) {
                this.$notify({
                    timeout: 8000,
                    message: message,
                    icon: icon,
                    type: style,
                    horizontalAlign: horizontal,
                    verticalAlign: vertical,
                });
            }
        },
        mounted() {
            this.fetchContents();
        }
    }
</script>
<style scoped>
    .right-button {
        display: flex;
        justify-self: flex-end;
        margin-right: 20px;
        margin-bottom: -15px;
    }
</style>